/*
 * File: /src/services/aiContextTypeService.js
 * Author: Roy Collins
 * -----
 * Copyright (c) 2026 AdBase, Inc.
 */

import { authedAxios } from '../shared/axiosWrapper';
import {
  S2_AI_CONTEXT_CONFIG_PATH,
  S2_AI_CONTEXT_TYPES_PATH,
} from '../constants';

export default {
  // All configured context types, unpaged, for selects and lookups
  getConfigs() {
    return authedAxios.get(S2_AI_CONTEXT_CONFIG_PATH);
  },
  fetchAiContextTypes(params = {}) {
    return authedAxios.get(S2_AI_CONTEXT_TYPES_PATH, {
      params: {
        filter: params.filters,
        limit: params.limit,
        offset: params.offset,
        sort: params.sort,
      },
    });
  },
  fetchAiContextType(id) {
    return authedAxios.get(S2_AI_CONTEXT_TYPES_PATH + id);
  },
  createAiContextType(payload) {
    return authedAxios.post(S2_AI_CONTEXT_TYPES_PATH, payload);
  },
  updateAiContextType(id, payload) {
    return authedAxios.patch(S2_AI_CONTEXT_TYPES_PATH + id, payload);
  },
  deleteAiContextType(id) {
    return authedAxios.delete(S2_AI_CONTEXT_TYPES_PATH + id);
  },
};
